import { ca } from '@cian/analytics';

export interface IUserTrackingInfo {
  deviceType: string;
  userId?: string;
  offerId?: string;
  regionId?: string;
}

export const trackSuccessAuth = (user: IUserTrackingInfo) => {
  ca('eventSite', {
    action: 'Success',
    category: 'MortgageDiscount',
    label: 'Auth_phone',
    page: {
      pageType: 'mortgage-discount-landing',
      siteType: user.deviceType,
    },
    user: {
      userId: user.userId,
    },
    products: [
      {
        id: user.offerId,
        offerType: 'offer',
        extra: {
          regionId: user.regionId,
        },
      },
    ],
  });
};

export const trackButtonClick = (user: IUserTrackingInfo, label: string, extra: Record<string, unknown> = {}) => {
  ca('eventSite', {
    action: 'Click',
    category: 'MortgageDiscount',
    label,
    page: {
      pageType: 'mortgage-discount-landing',
      siteType: user.deviceType,
      ...extra,
    },
    user: {
      userId: user.userId,
    },
    products: [
      {
        id: user.offerId,
        offerType: 'offer',
        extra: {
          regionId: user.regionId,
        },
      },
    ],
  });
};
